import Estimate from "@/accounting/domain/models/estimate";
import EstimateItem from "@/accounting/domain/models/estimate-item";
import EstimateItems from "@/accounting/domain/models/estimate-items";
import UnitPrice from "@/accounting/domain/models/unit-price";

export function toEstimate(data: any): Estimate {
  return new Estimate(
    data.id,
    data.title,
    data.attention,
    data.mention,
    data.projectId,
    data.projectName,
    data.staffName,
    data.projectClientName,
    data.status,
    toEstimateItems(data.items),
    data.taxRate,
    Boolean(data.printsExcludeTax),
    data.dateOfIssue,
    data.deadline
  );
}

export function toEstimateItems(data: any[]): EstimateItems {
  if (data.length > 0) {
    return new EstimateItems(...data.map(toEstimateItem));
  }
  return new EstimateItems();
}

export function toEstimateItem(data: any): EstimateItem {
  return new EstimateItem(
    data.id,
    data.unitName,
    data.unitType,
    new UnitPrice(data.unitPrice),
    new UnitPrice(data.unitLoss),
    data.amount,
    data.memo,
    Boolean(data.purchased),
    data.items.length > 0 ? "" : data.expenseCategoryId,
    toEstimateItems(data.items)
  );
}
